<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Coupon</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'couponId' || editMode" :for="field.name">{{ field.label }}:</label>
              <input v-if="(field.name !== 'active' && field.name !== 'status' && field.name !== 'couponId') || (field.name === 'couponId' && editMode)"
                     :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control responsive-input" :disabled="(field.name === 'couponId') && editMode">
              <input class="checkbox" v-else-if="field.name === 'active' || field.name === 'status'"
                     type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
            </div>

            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Coupon' }}</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {Coupon} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'CouponEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        couponId : this.$route.params.couponId,
        couponCode : this.$route.params.couponCode,
        percentage : this.$route.params.percentage,
        active: this.$route.params.active,
        status: this.$route.params.status,
      },
      editMode: false,
      fields: [
        { name: "couponId", label: "Coupon Id" },
        { name: "couponCode", label: "Coupon Code" },
        { name: "percentage", label: "Percentage" },
        { name: "active", label: "Active" },
        { name: "status", label: "Status" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.couponId) {
      this.editMode = true;
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new Coupon(
          this.editedConfig.couponId ,
          this.editedConfig.couponCode ,
          this.editedConfig.percentage ,
          this.editedConfig.active,
          this.editedConfig.status
      );

      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateCoupon(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'Coupons' });
        })
            .catch((error) => {
              console.error("Error updating Coupons:", error);
              if (error.response && error.response.data && error.response.data.message) {
                alert(error.response.data.message);
              }
            });
      } else {
        AdminService.insertCoupon(dataToSave).then(() => {

          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'Coupons' });
        })
            .catch((error) => {
              this.error = error.message
            });
      }
    }

  }
})
</script>
<style src="../../assets/style.css">
</style>
